import {
  CREATE_CHAT_SESSION,
  UPDATE_CHAT_SESSION,
  DELETE_CHAT_SESSION,
  SET_ACTIVE_SESSION,
  SET_CHAT_SESSIONS,
  CLEAR_CHAT_SESSIONS,
  FETCH_ANSWER_REQUEST,
  FETCH_ANSWER_SUCCESS,
  FETCH_ANSWER_FAILURE,
  SAVE_ANSWER
} from '../actions/types'

const initialState = {
  sessions: {}, // keyed by session ID
  activeSession: null,
  sessionOrder: [], // ordered list of session IDs
  loading: false,
  error: null
}

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_CHAT_SESSION: {
      const session = action.payload
      
      return {
        ...state,
        sessions: {
          ...state.sessions,
          [session.id]: session
        },
        sessionOrder: [session.id, ...state.sessionOrder]
      }
    }
    
    case UPDATE_CHAT_SESSION: {
      const { sessionId, updates } = action.payload
      
      if (!state.sessions[sessionId]) {
        return state
      }
      
      return {
        ...state,
        sessions: {
          ...state.sessions,
          [sessionId]: {
            ...state.sessions[sessionId],
            ...updates,
            updatedAt: new Date().toISOString()
          }
        }
      }
    }
    
    case DELETE_CHAT_SESSION: {
      const sessionId = action.payload
      const { [sessionId]: deletedSession, ...remainingSessions } = state.sessions
      
      return {
        ...state,
        sessions: remainingSessions,
        sessionOrder: state.sessionOrder.filter(id => id !== sessionId),
        activeSession: state.activeSession === sessionId ? null : state.activeSession
      }
    }
    
    case SET_ACTIVE_SESSION: {
      return {
        ...state,
        activeSession: action.payload
      }
    }
    
    case SET_CHAT_SESSIONS: {
      const sessions = action.payload
      const sessionsById = {}
      const sessionOrder = []
      
      sessions.forEach(session => {
        sessionsById[session.id] = session
        sessionOrder.push(session.id)
      })
      
      return {
        ...state,
        sessions: sessionsById,
        sessionOrder: sessionOrder.sort((a, b) => 
          new Date(sessions.find(s => s.id === b).createdAt) - 
          new Date(sessions.find(s => s.id === a).createdAt)
        )
      }
    }
    
    case CLEAR_CHAT_SESSIONS: {
      return {
        ...state,
        sessions: {},
        sessionOrder: [],
        activeSession: null
      }
    }
    
    case FETCH_ANSWER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    
    case FETCH_ANSWER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    
    case FETCH_ANSWER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    
    case SAVE_ANSWER: {
      const { sessionId, answerId, question, answer, citations } = action.payload
      
      return {
        ...state,
        sessions: {
          ...state.sessions,
          [sessionId]: {
            ...state.sessions[sessionId],
            answerId,
            title: question,
            answer,
            citations,
            savedAt: new Date().toISOString()
          }
        }
      }
    }
    
    default:
      return state
  }
}